export const MEMPOOL_API_URL = 'https://mempool.space/api';
export const MEMPOOL_API_URL_TESTNET = 'https://mempool.space/testnet/api';
export const MEMPOOL_API_URL_SIGNET = 'https://mempool.space/signet/api';
